import { Injectable } from '@angular/core';
import { BaseFirestoreService } from './base-firestore.service';
import { DocumentReference } from '@angular/fire/firestore';
import { SMOrderBasic } from 'src/app/models/SMOrderBasic';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OrderService {

  COLLECTION_NAME = 'Orders';

  constructor(private base: BaseFirestoreService) {
  }

  async createOrder(order: SMOrderBasic): Promise<DocumentReference> {
    return await this.base.createRecord(order, this.COLLECTION_NAME);
  }

  async getOrders(brandID): Promise< Observable<any[]>> {
    return this.base.getFirestore().collection(this.COLLECTION_NAME, ref => {
      return ref.where('brandID', '==', brandID);
    }).valueChanges({ idField: 'id' });
  }

  async updateOrder(order: SMOrderBasic): Promise<boolean> {
    return await this.base.updateRecord(order.id, order, this.COLLECTION_NAME);
  }
}
